import { combineReducers } from "redux";
import { RESET_STORE } from "../actions/actionTypes";
import { api } from "../../common/api-utils";
// import { store } from "../config-store";

import auth from "./auth.reducer";
import dashboard from "./dashboard.reducer";
import modules from "./module.reducer";
import calendar from "./calendar.reducer";
import config from "./config.reducer";
import edit from "./edit.reducer";
import detail from "./detail.reducer";
import emails from "./emails.reducer";

const appReducer = combineReducers({
  auth,
  dashboard,
  modules,
  config,
  edit,
  detail,
  emails,
  calendar
});

export default (state, action) => {
  if (action.type === 'RESET_STORE'){     
    state = undefined;
  }
  // TODO: Remove this when moving to PROD
  // if (action.type === "persist/REHYDRATE") {
  //   const url = action?.payload?.config?.baseUrl ? action.payload.config.baseUrl : state.config.baseUrl;
  //   api.setBaseURL(url);
  // }

  return appReducer(state, action);
};
